import React, { useEffect } from "react";
import { useSelector, RootStateOrAny } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation, usePermissions } from "hooks";
import { translations } from "./translations";
import {
  PaginateBusinessState,
} from "store/ducks/settings/business";

import * as S from "./styles";
import { MainContainer, Paginator, MenuSelector } from "components/shared";
import { GridBusiness, FilterBusiness } from "components/settings";
import { useFilters } from 'hooks/useFilters';

export const ListBusiness: React.FC = () => {
  const history = useHistory();
  const { getTranslation } = useTranslation(translations);
  const { checkUserPermission } = usePermissions();
  const { getData } = useFilters('business')
  
  const { data, loading, pagination } = useSelector<RootStateOrAny>(
    (state) => state.paginateBusiness
  ) as PaginateBusinessState;

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation("configuracoes")}
          <MenuSelector page="business" />
          {loading && <S.LoadingPage />}
        </h1>
        <S.HeaderButtons>
          {checkUserPermission("insertBusinessLine") && (
            <S.ButtonMini
              onClick={() => history.push("/settings/business/new")}
            >
              {getTranslation("novaLinha")}
            </S.ButtonMini>
          )}
          <FilterBusiness />
        </S.HeaderButtons>
      </S.PageHeader>
      <S.PageContent>
        <GridBusiness businesses={data} />
        <Paginator
          pagination={pagination}
          settingsPage='business'
          loading={loading}
        />
      </S.PageContent>
    </MainContainer>
  );
};
